import React, { useEffect, useState } from "react";
import { HiOutlineChevronRight } from "react-icons/hi";
import { useLocation, Link } from "react-router-dom";

/**
 * SEO-Optimized Breadcrumb Component
 * Includes Schema Markup for Google Rich Results
 */
const Breadcrumbs = ({ prevLocation = "Home", title }) => {
  const location = useLocation();
  const [locationPath, setLocationPath] = useState("");

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    setLocationPath(path || "home");
  }, [location]);

  // Convert URL to readable text
  const readableLabel = (text) =>
    text.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <div className="w-full py-10 flex flex-col gap-3">

      {/* SEO Title */}
      <h1 className="text-5xl text-primeColor font-titleFont font-bold">
        {title || readableLabel(locationPath)}
      </h1>

      {/* Visual Breadcrumb */}
      <nav
        className="text-sm font-normal text-lightText capitalize flex items-center"
        aria-label="Breadcrumb"
      >
        <Link to="/" className="hover:text-primeColor duration-200">
          {prevLocation || "Home"}
        </Link>

        <span className="px-1">
          <HiOutlineChevronRight />
        </span>

        <span className="capitalize font-semibold text-primeColor">
          {readableLabel(locationPath)}
        </span>
      </nav>

      {/* JSON-LD Breadcrumb Schema for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${window.location.origin}/`,
            },
            {
              "@type": "ListItem",
              position: 2,
              name: readableLabel(locationPath),
              item: `${window.location.origin}/${locationPath}`,
            },
          ],
        })}
      </script>
    </div>
  );
};

export default Breadcrumbs;
